
import React from "react";
import { Link } from "react-router-dom";

const ElfsightStoreLocator = () => {
  return (
    <div className="map-container">
      {/* PamPam Holiday Lights Map */}
      <iframe
        title="Tamarac Holiday Lights Contest Map"
             style={{
    height: "85vh",
    minHeight: "500px",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    borderRadius: "10px",
    display: "block"
  }}
        width="100%"

        src="https://www.pampam.city/holiday-lights-contest-map-wBCk7ztOPeRZo5YRLX6o"
        
        allowFullScreen

      />

      <Link to="/" className="home-btn">
        ⬅️ Back to Main Page
      </Link>
    </div>
  );
};

export default ElfsightStoreLocator;


